import { Injectable } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Injectable({ providedIn: 'root' })
export class ModalService {

	constructor(private modalService: BsModalService) { }

	show<T>(component: any, data: T, success: (resultData: T, status: StatusResultModalEdit) => void, size: 'sm' | 'md' | 'lg' = 'lg'): void {
		const modalOption = new ModalOptions();
		modalOption.class = `modal-${size}`;
		modalOption.backdrop = 'static';
		modalOption.keyboard = false;
		modalOption.initialState = {
			data: data,
			success: success
		};
		this.modalService.show(component, modalOption);
	}

	showAny(component: any, size: 'sm' | 'md' | 'lg' = 'lg'): void {
		this.show<any>(component, null, null, size);
	}

	openUpload<T>(component: any, data: T, success: (resultData: T, status: StatusResultModalEdit) => void, size: 'sm' | 'md' | 'lg' = 'lg'): void {
		const modalOption = new ModalOptions();
		modalOption.class = `modal-${size}`;
		modalOption.backdrop = 'static';
		modalOption.keyboard = false;
		modalOption.initialState = {
			data: data,
			success: success
		};
		this.modalService.show(component, modalOption);
	}

}

export enum StatusResultModalEdit {
	SAVE,
	DELETE,
	CANCEL
}
